class ProductLabels extends HTMLElement {
  constructor() {
    super();
    this.productLabelsConfigs = JSON.parse(document.querySelector('[data-product-labels]')?.innerHTML);
    this.productLabels = this.productLabelsConfigs.labels;
    this.product = {
      id: this.getAttribute('data-product-id'),
      collections: this.getAttribute('data-product-collections').split(','),
      price: parseInt(this.getAttribute('data-product-price') ?? 0),
      compare_at_price: parseInt(this.getAttribute('data-product-compare-at-price') ?? 0),
    };
  }

  connectedCallback() {
    const product = this.product;
    const context = this.getContext();
    const labels = this.productLabels.filter((label) => this.isVisibleInContext(label, context));
    labels.forEach((label) => this.renderProductLabel(product, label));
  }

  // Where this label container is rendered: home, product, collection, search, cart (or null for other pages)
  getContext() {
    const explicitContext = this.getAttribute('data-context');
    if (explicitContext) return explicitContext;
    if (this.closest('cart-drawer')) return 'cart';
    if (this.closest('.main-search__results')) return 'search';

    const bodyClasses = document.body.classList;
    if (bodyClasses.contains('template-index')) return 'home';
    if (bodyClasses.contains('template-collection')) return 'collection';
    if (bodyClasses.contains('template-search')) return 'search';
    if (bodyClasses.contains('template-cart')) return 'cart';
    // Product cards (e.g. related products) on a PDP are product lists, not the PDP itself
    if (bodyClasses.contains('template-product')) return 'collection';
    return null;
  }

  // Each label is checked against its own visibility settings only
  isVisibleInContext(label, context) {
    if (!context || !label.visibility) return true;
    return label.visibility[context] === true;
  }

  renderProductLabel(product, label) {
    const id = label.id;
    let text = label.text;
    let has_reduction = false;
    if (label.is_reduction_label) {
      if (product.compare_at_price > product.price) {
        has_reduction = true;
      }
      if (has_reduction) {
        switch (true) {
          case /\[percent\]/.test(text):
            const percent = (100 / product.compare_at_price) * (product.compare_at_price - product.price);
            text = text.replace('[percent]', percent.toFixed(0) + '%');
            break;
          case /\[amount\]/.test(text):
            const amount = product.compare_at_price / 100 - product.price / 100;
            const money =
              Intl.NumberFormat('en', { style: 'currency', currency: window.Shopify.currency.active }).format(0)[0] +
              amount.toFixed(2).replace('.', ',');
            text = text.replace('[amount]', money);
            break;
          default:
            break;
        }
      }
    }
    const active = label.active;
    const show_on_desktop = label.show_on_desktop;
    const show_on_mobile = label.show_on_mobile;
    const image = label.image;
    const text_color = label.text_color;
    const bg_color = label.bg_color;
    const is_bold = label.is_bold;
    const link = label.link;

    const current_product_id = product.id;
    const current_product_collections = product.collections;
    const label_only_for_products = label.label_products;
    const label_only_for_collections = label.label_collections;

    if (!active) return;

    if (Object.keys(label_only_for_products).length > 0) {
      //CHECKS FOR MATCHING PORDUCTS
      var matching_product = false;
      label_only_for_products.forEach((product) => {
        if (product.id == current_product_id) {
          matching_product = true;
        }
      });
    }

    if (Object.keys(label_only_for_collections).length > 0) {
      //CHECKS FOR MATCHING COLLECTIONS
      var matching_collection = false;
      label_only_for_collections.forEach((collection) => {
        current_product_collections.forEach((col) => {
          if (col == collection.handle) {
            matching_collection = true;
          }
        });
      });
    }

    if (label.is_reduction_label) {
      if (!has_reduction) return;
      if (Object.keys(label_only_for_collections).length > 0 || Object.keys(label_only_for_products).length > 0) {
        if (!matching_product) {
          if (!matching_collection) {
            return;
          }
        }
      }
    } else {
      if (!matching_product) {
        if (!matching_collection) {
          return;
        }
      }
    }

    const labelWrapper = document.createElement('div');
    labelWrapper.setAttribute('data-label-id', id);

    if (!show_on_desktop) {
      labelWrapper.classList.add('desktop-hidden');
    } else if (labelWrapper.classList.contains('desktop-hidden')) {
      labelWrapper.classList.remove('desktop-hidden');
    }
    if (!show_on_mobile) {
      labelWrapper.classList.add('mobile-hidden');
    } else if (labelWrapper.classList.contains('mobile-hidden')) {
      labelWrapper.classList.remove('mobile-hidden');
    }

    const labelEl = document.createElement('span');
    labelEl.setAttribute('data-label-id', id);

    if (image) {
      const imageEl = document.createElement('img');
      imageEl.setAttribute('loading', 'lazy');
      imageEl.setAttribute('src', image);
      labelEl.appendChild(imageEl);
    } else {
      labelEl.style.color = text_color;
      labelEl.style.backgroundColor = bg_color;
      labelEl.innerText = text;
    }

    if (is_bold) {
      labelEl.style.fontWeight = 'bold';
    }

    if (link) {
      const linkEl = document.createElement('a');
      linkEl.setAttribute('href', link);
      linkEl.appendChild(labelEl);
      labelWrapper.appendChild(linkEl);
    } else {
      labelWrapper.appendChild(labelEl);
    }
    this.appendChild(labelWrapper);
  }
}

// Define the custom element
customElements.define('product-labels', ProductLabels);
